export default __webpack_public_path__ + "be2969475125627f64ac73757acc9e09.svg";